import React from 'react';
import { useBrand } from '../../../app/config/brand';

interface RadioCardProps {
  label: string;
  description: string;
  checked: boolean;
  onChange: () => void;
  name: string;
}

export const RadioCard: React.FC<RadioCardProps> = ({ label, description, checked, onChange, name }) => {
  const brand = useBrand();
  return (
    <label
      className="flex items-start gap-4 p-5 rounded-xl cursor-pointer transition-all border-2"
      style={{
        borderColor: checked ? brand.colors.primary : brand.colors.border,
        backgroundColor: checked ? brand.colors.primaryLight : 'white',
      }}
    >
      <input type="radio" name={name} checked={checked} onChange={onChange} className="mt-1 w-5 h-5" style={{ accentColor: brand.colors.primary }} aria-label={label} />
      <div>
        <div className="font-semibold" style={{ color: brand.colors.secondary }}>{label}</div>
        <div className="text-sm mt-1" style={{ color: brand.colors.textLight }}>{description}</div>
      </div>
    </label>
  );
};
